/**
 * UN/ARCHIVE Theme - MAISON SPECIAL Style
 * Enhanced JavaScript with smooth scroll animations
 */

(function() {
  'use strict';

  // ==========================================
  // Intersection Observer for Scroll Animations
  // ==========================================
  const observeElements = () => {
    const elements = document.querySelectorAll('.scroll-fade');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));
  };

  // ==========================================
  // Smooth Scroll for Anchor Links
  // ==========================================
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href !== '#' && href !== '#!') {
          e.preventDefault();
          const target = document.querySelector(href);
          if (target) {
            const headerOffset = 80;
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  };

  // ==========================================
  // Lazy Loading Images
  // ==========================================
  const initLazyLoading = () => {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            img.classList.add('loaded');
            imageObserver.unobserve(img);
          }
        });
      });

      images.forEach(img => imageObserver.observe(img));
    }
  };

  // ==========================================
  // Header Scroll Behavior
  // ==========================================
  const initHeaderScroll = () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    let lastScroll = 0;
    let ticking = false;

    const updateHeader = () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 80) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
      
      lastScroll = currentScroll;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    });
  };

  // ==========================================
  // Mobile Menu
  // ==========================================
  const initMobileMenu = () => {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-nav]');
    
    if (!menuToggle || !nav) return;

    menuToggle.addEventListener('click', () => {
      nav.classList.toggle('active');
      menuToggle.classList.toggle('active');
      document.body.style.overflow = nav.classList.contains('active') ? 'hidden' : '';
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (nav.classList.contains('active') && 
          !nav.contains(e.target) && 
          !menuToggle.contains(e.target)) {
        nav.classList.remove('active');
        menuToggle.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('active')) {
        nav.classList.remove('active');
        menuToggle.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  };

  // ==========================================
  // Product Image Gallery
  // ==========================================
  const initProductGallery = () => {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    
    galleries.forEach(gallery => {
      const mainImage = gallery.querySelector('[data-main-image]');
      const thumbnails = gallery.querySelectorAll('[data-thumbnail]');
      
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const newSrc = thumb.dataset.image;
          
          if (mainImage && newSrc) {
            mainImage.src = newSrc;
            thumbnails.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          }
        });
      });
    });
  };

  // ==========================================
  // Quantity Selector
  // ==========================================
  const initQuantitySelectors = () => {
    const selectors = document.querySelectorAll('[data-quantity-selector]');
    
    selectors.forEach(selector => {
      const decreaseBtn = selector.querySelector('[data-quantity-decrease]');
      const increaseBtn = selector.querySelector('[data-quantity-increase]');
      const input = selector.querySelector('[data-quantity-input]');
      
      if (decreaseBtn && increaseBtn && input) {
        decreaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          const minValue = parseInt(input.min) || 1;
          if (currentValue > minValue) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
        
        increaseBtn.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          const maxValue = parseInt(input.max) || Infinity;
          if (currentValue < maxValue) {
            input.value = currentValue + 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
    });
  };

  // ==========================================
  // Initialize All
  // ==========================================
  const init = () => {
    // Remove no-js class
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');

    // Initialize features
    observeElements();
    initSmoothScroll();
    initLazyLoading();
    initHeaderScroll();
    initMobileMenu();
    initProductGallery();
    initQuantitySelectors();

    console.log('UN/ARCHIVE Theme (MAISON SPECIAL Style) initialized');
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose utilities
  window.UNArchive = {
    observeElements,
    initLazyLoading
  };

})();
